<template>
  <div class="signPayReturn">
    <img style="width: 160px;height: auto;margin: 0 auto;" src="../assets/sign.png" alt="">
    <span class="title">请到签署小程序查看支付结果</span>
  </div>
</template>

<script>

export default {
  name: "signPayReturn",
  components: {},

  data() {
    return {
    }
  },
  created() {
  },

  destroyed() {
  },

  methods: {
  }
}
</script>

<style scoped>
.signPayReturn {
  width: 100%;
  padding-top: 12px;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  align-items: center;
}
.title {
    font-size: 20px;
    font-weight: 700;
    color: #1778ff
}
</style>
